export function formatStatus(status)
{
    if (!status)
    {
        return null;
    }
    const requestStatusMap = {
        DefaultRequestProcessing: 'Processing',
        DefaultRequestNew: 'New',
        DefaultRequestLive: 'Live',
        DefaultRequestArchived: 'Archived',
        UJVRequestProcessing: 'Processing',
        UJVRequestNew: 'New',
        UJVRequestLive: 'Live',
        UJVRequestArchived: 'Archived',
        FTARequestOpportunity: 'Opportunity',
        FTARequestDiscovery: 'Discovery',
        FTARequestDesignAndReserve: 'DesignAndReserve',
        FTARequestBooked: 'Booked',
        FTARequestClosedWon: 'ClosedWon',
        FTARequestClosedLost: 'ClosedLost',
    };

    return requestStatusMap[status] ?? status;
}
